// SPDX-License-Identifier: AGPL-3.0-or-later

import {GenericErrorModal} from '@app/features/app/components/alerts/GenericErrorModal';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type {ReactElement} from 'react';

interface GroupOwnershipTransferFailedModalProps {
	username: string;
}
export const GroupOwnershipTransferFailedModal = observer(({username}: GroupOwnershipTransferFailedModalProps) => {
	const {t} = useLingui();
	const message: ReactElement = (
		<Trans>
			Ownership could not be transferred to <strong>{username}</strong> at this time.
		</Trans>
	);
	return <GenericErrorModal title={t`Failed to Transfer Ownership`} message={message} />;
});
